import { useLocation } from 'quartz-routing/react-router';
import I18n from 'I18n';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIsIframeableUrl, getIsIframePreviewUrl } from '../../utils/urls';
import { useCheckoutIframeableContext } from '../../context/IframeableContext';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MeetingTime = () => {
  var _iframeableContext$pa;
  const iframeableContext = useCheckoutIframeableContext();
  const {
    pathname
  } = useLocation();
  const eventDate = iframeableContext === null || iframeableContext === void 0 || (_iframeableContext$pa = iframeableContext.passthruProps) === null || _iframeableContext$pa === void 0 ? void 0 : _iframeableContext$pa.eventDate;
  if (!getIsIframeableUrl(pathname) || getIsIframePreviewUrl(pathname) || !eventDate) return null;
  return /*#__PURE__*/_jsx(CardWrapper, {
    marginBlockEnd: "400",
    children: /*#__PURE__*/_jsxs(CardSection, {
      padding: "600",
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx("b", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "payments.meetingTime.header"
          })
        })
      }), /*#__PURE__*/_jsx(FormattedDateTime, {
        value: I18n.moment.userTz(eventDate),
        format: "LLLL"
      })]
    })
  });
};
export default MeetingTime;